export const WORDPRESS_CONFIG = {
    SITE_URL: import.meta.env.VITE_WORDPRESS_SITE_URL || 'https://cms.salamatlab.com',
    API_BASE: '/wp-json/wp/v2',
    DEFAULT_PER_PAGE: parseInt(import.meta.env.VITE_WORDPRESS_PER_PAGE || '10'),
    FEATURED_ARTICLES_COUNT: parseInt(import.meta.env.VITE_WORDPRESS_FEATURED_COUNT || '4'),
    CACHE_DURATION: parseInt(import.meta.env.VITE_WORDPRESS_CACHE_DURATION || '300000'),
    REQUEST_TIMEOUT_MS: parseInt(import.meta.env.VITE_WORDPRESS_TIMEOUT_MS || '25000'),
    ENABLE_CACHE: import.meta.env.VITE_WORDPRESS_ENABLE_CACHE !== 'false',
    DEFAULT_IMAGE: import.meta.env.VITE_WORDPRESS_DEFAULT_IMAGE || '/placeholder.svg'
};
export const getWordPressApiUrl = (endpoint: string = '') => {
    return `${WORDPRESS_CONFIG.SITE_URL}${WORDPRESS_CONFIG.API_BASE}${endpoint}`;
};
export const getPostsEndpoint = (params: Record<string, string | number> = {}) => {
    const searchParams = new URLSearchParams();
    searchParams.append('_embed', '1');
    searchParams.append('per_page', WORDPRESS_CONFIG.DEFAULT_PER_PAGE.toString());
    Object.entries(params).forEach(([key, value]) => {
        searchParams.append(key, value.toString());
    });
    return `${getWordPressApiUrl('/posts')}?${searchParams.toString()}`;
};
export const validateWordPressConfig = (): {
    isValid: boolean;
    errors: string[];
} => {
    const errors: string[] = [];
    if (!WORDPRESS_CONFIG.SITE_URL || WORDPRESS_CONFIG.SITE_URL === 'https://your-wordpress-site.com') {
        errors.push('آدرس سایت وردپرس تنظیم نشده است. لطفاً در فایل config/wordpress.ts تغییر دهید.');
    }
    if (!WORDPRESS_CONFIG.SITE_URL.startsWith('http')) {
        errors.push('آدرس سایت وردپرس باید با http:// یا https:// شروع شود.');
    }
    if (WORDPRESS_CONFIG.DEFAULT_PER_PAGE < 1 || WORDPRESS_CONFIG.DEFAULT_PER_PAGE > 100) {
        errors.push('تعداد مقالات در هر صفحه باید بین 1 تا 100 باشد.');
    }
    if (WORDPRESS_CONFIG.FEATURED_ARTICLES_COUNT < 1 || WORDPRESS_CONFIG.FEATURED_ARTICLES_COUNT > 20) {
        errors.push('تعداد مقالات نمایشی در صفحه اصلی باید بین 1 تا 20 باشد.');
    }
    return {
        isValid: errors.length === 0,
        errors
    };
};
if (import.meta.env.DEV) {
    console.log('🔧 WordPress Configuration:', WORDPRESS_CONFIG);
    const validation = validateWordPressConfig();
    if (!validation.isValid) {
        console.warn('⚠️ WordPress Configuration Issues:', validation.errors);
    }
}
